import { BaseComponent } from '../../base-component';
import { ImagesState } from './images.component';

export type ChangeImageEvent = {
    index: number;
    emitter: ImagesSubComponent;
};

export abstract class ImagesSubComponent extends BaseComponent {
    private state: ImagesState;

    constructor(state: ImagesState) {
        super();
        this.state = state;
        o_global.eventQBus.on('ft5.pdp-images.changeItem', (data: ChangeImageEvent) => {
            if (data.emitter !== this) {
                this.onItemChanged(data.index);
            }
        });
    }

    protected abstract onItemChanged(index: number): void;

    protected changeItem(index: number) {
        o_global.eventQBus.emit('ft5.pdp-images.changeItem', {
            index,
            emitter: this,
        } satisfies ChangeImageEvent);
    }

    protected getImageIds() {
        return this.state.imageIds;
    }

    protected isVideo(index: number) {
        return index === this.getVideoIndex();
    }

    protected hasVideo() {
        return this.state.videoIndex > -1;
    }

    protected getVideoAssetKey() {
        return this.state.videoAssetKey;
    }

    protected getVideoIndex() {
        return this.state.videoIndex;
    }

    protected toImageIndex(index: number) {
        return this.hasVideo() && index > this.getVideoIndex() ? index - 1 : index;
    }

    protected toFullIndex(index: number) {
        return this.hasVideo() && index >= this.getVideoIndex() ? index + 1 : index;
    }
}
